import React, { useState } from "react"

import "./style.css"

const LangSupportPanel = ({ onLangChange, langName }) => {
  return (
    <div className="lsp-wrapper">
      <div
        className={`lng-button ${langName === "he" ? "active-lng" : ""}`}
        onClick={() => {
          onLangChange("he")
        }}
      >
        <p>עברית</p>
      </div>
      <p className="divider">&nbsp;/&nbsp;</p>
      <div
        className={`lng-button ${langName === "en" ? "active-lng" : ""}`}
        onClick={() => {
          onLangChange("en")
        }}
      >
        <p>English</p>
      </div>
      <p className="divider">&nbsp;/&nbsp;</p>
      <div
        className={`lng-button ${langName === "ru" ? "active-lng" : ""}`}
        onClick={() => {
          onLangChange("ru")
        }}
      >
        <p>Русский</p>
      </div>
    </div>
  )
}

export default LangSupportPanel
